import { initializeApp } from 'firebase/app';
import { getAuth, initializeRecaptchaConfig } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyAuiNqqlTLgEefdvZOXT4tfGKAqy_XJV2c",
  authDomain: "aldealix-reservation.firebaseapp.com",
  projectId: "aldealix-reservation",
  storageBucket: "aldealix-reservation.firebasestorage.app",
  messagingSenderId: "258966414953",
  appId: "1:258966414953:web:1c897e3925d63ba06924f8"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Clave reCAPTCHA Enterprise para Phone Auth
export const RECAPTCHA_SITE_KEY = '6LeNh4osAAAAAMFBDqdnAQ6ch0Ddh-yeZOTJ5Oz3';
